import { render } from "./InAppPurchaseIntegrationSettings.vue?vue&type=template&id=1c1adbb6"
import script from "./InAppPurchaseIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./InAppPurchaseIntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__